/**
 * Voice mic button rendered in the composer's right slot when no
 * draft text is present and `tenant.voice_enabled` is true.
 *
 * Visually a 40px coral pill (the primary affordance in the
 * composer when voice is enabled). The send button replaces it the
 * moment the operator types something so the right slot always
 * holds exactly one action.
 *
 * Disabled while the chat is streaming so the operator does not
 * start a voice call mid-token.
 */

import { MicIcon } from "../icons";

interface Props {
  onClick: () => void;
  disabled: boolean;
  ariaLabel: string;
}

export function VoiceButton({ onClick, disabled, ariaLabel }: Props) {
  return (
    <button
      type="button"
      class="rh-mic-primary"
      aria-label={ariaLabel}
      title={ariaLabel}
      onClick={onClick}
      disabled={disabled}
    >
      <MicIcon />
    </button>
  );
}
